import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import RoundedImageIcon from './components/RoundedImageIcon'
import ExpandableSection from './components/ExpandableSection'
import icons from './enums/icons'
import connectPropTypes from './utilities/connectPropTypes'
import getNormalisedParameters from './utilities/getNormalisedParameters'
import styles from './ActivateUser.icss'
import getDecodedURIComponent from './utilities/getDecodedURIComponent'

class ActivateUser extends React.Component {
	constructor(props) {
		super(props)
		const parsedSearch = getNormalisedParameters(this.props.location.search)
		this.state = {
			uid: getDecodedURIComponent(parsedSearch.uid || props.match.params.uid)
		}

		this.handleClickActivate = this.handleClickActivate.bind(this)
	}

	componentDidMount() {
		this.props.appHeading({
			text: this.context.translate('Activate user'),
			icon: icons.whiteUser
		})
		if (this.state.uid) {
			this.props.userProfileFetch({ userName: this.state.userName, uid: this.state.uid })
		}
	}

	handleClickActivate() {
		this.props.activateNewUser({ uid: this.state.uid })
	}

	render() {
		const isAdmin = this.props.user.isAdmin
		const up = this.props.userProfile
		if (!this.state.uid || !up) {
			return null
		}
		const cap = str => str.charAt(0).toUpperCase() + str.slice(1)
		const bits = Object.keys(up).reduce((acc, key) => {
			if (['email', 'fullName', 'uid', 'userName'].indexOf(key) !== -1) {
				acc.push({ label: cap(key), value: up[key] })
			}
			return acc
		}, [])
		const hasBeenActivated = (this.props.activateNewUserUid === this.state.uid) || up.isActivated
		const photoURL = up.images || up.profileImage || up.photoURL

		return (
			<section>
				{isAdmin && (
					<div className={styles.surround}>
						{!hasBeenActivated && (
							<section>
								<h3>{this.context.translate('Activate user')}</h3>
								<p>{this.context.translate('You are about to activate the following user:')}</p>
								{photoURL && (
									<RoundedImageIcon
										className={styles.profileImageLarge}
										content={photoURL}
										cover
									/>
								)}
								<div className={styles.lines}>
									{bits.map(bit => (
										<div className={styles.line} key={`line${bit.label}`}>
											<span className={styles.label}>{bit.label}</span>
											<span className={styles.value}>{bit.value}</span>
										</div>
									))}
								</div>
								<div className={styles.expander}>
									<ExpandableSection title={this.context.translate('See all userprofile data')}>
										<pre><code>{JSON.stringify(up, null, 4)}</code></pre>
									</ExpandableSection>
								</div>
								<div className={styles.profileHeaderDetails}>
									<Button variant="contained" type="button" onClick={this.handleClickActivate}>
										{this.props.userActivationInProgress ? <CircularProgress size={24} thickness={4} /> : this.context.translate('Activate user')}
									</Button>
								</div>
							</section>
						)}
						{hasBeenActivated && !this.props.userActivationFailed && (
							<section>
								<h3>{this.context.translate('Activate user')}</h3>
								<p>{this.context.translate('User successfully activated! Please inform the user to logout and back in again to gain access to the full set of features in Kitfit')}</p>
							</section>
						)}
						{this.props.userActivationFailed && (
							<section>
								<h3>{this.context.translate('Activate user')}</h3>
								<p>{this.context.translate('User activation failed!')}</p>
							</section>
						)}
					</div>
				)}
				{!isAdmin && (
					<div className={styles.surround}>
						<section>
							<h3>{this.context.translate('Activate user')}</h3>
							<p>{this.context.translate('You must be logged in as an administrator to activate a user')}</p>
						</section>
					</div>
				)}
			</section>
		)
	}
}

ActivateUser.contextTypes = {
	translate: PropTypes.func
}

ActivateUser.propTypes = {
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired,
		search: PropTypes.string
	}).isRequired,
	match: PropTypes.shape({
		params: PropTypes.object.isRequired
	}).isRequired,
	history: PropTypes.shape({
		goBack: PropTypes.func.isRequired
	}).isRequired,
	appHeading: PropTypes.func.isRequired,
	userProfileFetch: PropTypes.func.isRequired,
	activateNewUser: PropTypes.func.isRequired,
	activateNewUserUid: PropTypes.string,
	userActivationFailed: PropTypes.bool,
	userActivationInProgress: PropTypes.bool,
	userProfile: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	user: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
}

ActivateUser.defaultProps = {
	userProfile: undefined,
	activateNewUserUid: undefined,
	userActivationFailed: false,
	userActivationInProgress: false
}

export const testing = {
	ActivateUser
}

export default connectPropTypes(ActivateUser)



// WEBPACK FOOTER //
// ./src/ActivateUser.jsx